module.exports = __webpack_public_path__ + "static/c_mingso-137b223255b21c2f4d9ca70030c5268b.png";